module.exports = __webpack_public_path__ + "img/afl.fb64d248.png";